import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], total: 0 });
  const [open, setOpen] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setCart({ items: [], total: 0 }); return; }
    try {
      const { data } = await client.get("/cart");
      setCart(data);
    } catch { setCart({ items: [], total: 0 }); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const addItem = async (product_id, quantity=1, size=null, color=null) => {
    const { data } = await client.post("/cart/add", { product_id, quantity, size, color });
    setCart(data);
    setOpen(true);
  };
  const removeItem = async (index) => {
    const { data } = await client.post("/cart/remove", { index });
    setCart(data);
  };
  const updateQty = async (index, quantity) => {
    const { data } = await client.post("/cart/update", { index, quantity });
    setCart(data);
  };
  const count = cart.items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ cart, refresh, addItem, removeItem, updateQty, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}
